import React, { FC, useLayoutEffect, useState, useRef } from 'react'
import { sleep } from '@dt/fe-utils'
import { Input, Icon } from '@cps'
import { locationMobx } from '@mobxStore'
import markerImg from '@img/mapMarker.png'
import markerImgStore from '@img/storeMarker.png'
import storeChangeImg from '@img/storeChange.png'
import { restaurantConfig, restaurantCenter } from 'restaurant'
import './index.scss'
import { find, some } from '@dt/fe-utils/dist/lodash'

// interface
interface IProps {
  location: {
    latitude: number;
    longitude: number;
  };
  mapShow?(type: boolean): void;
  isSearch: boolean;
  handleStoreClassify: {};
  storeDetail: {};
  onSelectStore?(store?: IViewStore): void;
  isLBS: boolean;
  isStoreMore: boolean;
  setIsStoreMore(type: boolean): void;
  setLBS(obj: {}): void;
  setSearchTitle(obj: string): void;
}
let map: any
let centerMarker: any
// let labelStyle = {
//   color: '#fff',
//   backgroundColor: '#FE4848',
//   borderRadius: '5px',
//   paddingLeft: '10px',
//   paddingRight: '10px',
//   fontSize: '14px',
//   height: '24px',
//   lineHeight: '22px',
//   fontFamily: '微软雅黑'
// }
let labelStyle = {
  color: '#fff',
  backgroundColor: '0',
  fontSize: '12px',
  border: '0',
  height: '24px',
  lineHeight: '14px',
  fontWeight: 'bold',
  fontFamily: '微软雅黑'
}
/** 地图搜索字段 */
const keyList = [
  'Br', 'Cr', 'Vr', 'Ir', 'Wr', 'Dr', 'Er', 'Fr', 'Gr', 'Hr',
  'Jr', 'Ar', 'Kr', 'Lr', 'Mr', 'Nr', 'Or', 'Pr', 'Qr', 'Rr',
  'Sr', 'Tr', 'Ur', 'Xr', 'Yr', 'Zr', 'qk', 'fR'
]
/** 缓存搜索字段 */
let saveBdKey = ''

let label: any
const BaiduMap = (props: IProps) => {
  const { location, handleStoreClassify, isSearch, mapShow, storeDetail, onSelectStore, setIsStoreMore, setSearchTitle } = props
  const baiduRef = useRef<HTMLDivElement>()
  const [searchArr, setSearchArr] = useState<any[]>([])
  const [mapEnd, setMapEnd] = useState<boolean>(false)
  // 搜索
  const searchLocal = (value: string) => {
    if (map) {
      const myKeys = value
      const local = new BMap.LocalSearch(map, {
        onSearchComplete: (res: any) => {
          console.log('百度返回搜索===>', res)
          // const bdKey = res?.[saveBdKey]?.length ? saveBdKey : find(keyList, (bdKey: string) => !!res?.[bdKey]?.length) || saveBdKey
          // saveBdKey = bdKey
          // setSearchArr((res?.[bdKey] || []))
          const list = []
          const num = res?.getCurrentNumPois?.() || 0
          for (let i = 0; i < num; i++) {
            const poi = res?.getPoi?.(i)
            /** 过滤不带 src_type 的数据 */
            if ('src_type' in poi && poi.src_type) {
              list.push(poi)
            }
          }
          console.log('百度返回搜索列表===>', list)
          setSearchArr(list)
        }
      })
      local.search(myKeys, map.getBounds())
    }
  }
  // 处理店铺名显示
  const dealStoreName = (storeName = '') => {
    storeName = storeName.trim()
    let offsetY = -8
    let name = ''
    let nArr = storeName.split(' ')
    if (nArr.length > 1) {
      nArr.forEach((str, idx) => {
        name += str + ' '
        if (name.zhLength() + (nArr[idx + 1] || '')?.zhLength() > 9 && !/<\/br>/.test(name)) {
          name.zhLength() > 10 && (name += '...')
          name += '</br>'
          offsetY = -15
        }
      })
      const [line1, line2 = ''] = name.split(/<\/br>/g)
      if (line2.zhLength() > 9) {
        name = name.replace(line2, '')
        name += (line2.slice(0, 14) + '...')
      }
    } else {
      const line1 = storeName.slice(0, 18)
      const line1Len = line1.zhLength()
      if (line1Len > 9) {
        const _l1s = 9 + (18 - line1Len)
        const _line1 = storeName.slice(0, _l1s)
        const line2 = storeName.slice(_line1.length, _line1.length + 18)
        const line2Len = line2.zhLength()
        const _l2s = _l1s + 9 + (18 - line2Len)
        const _line2 = line2Len > 9 ? storeName.slice(_l1s, _l2s - 3) + '...' : storeName.slice(_l1s, _l2s)
        name = `${_line1}</br>${_line2}`
        offsetY = -15
      } else {
        name = storeName
      }
    }
    return { name, offsetY }
  }
  // 创建文本标注对象
  const setLabel = (storeDetail, location, zIndex = 6) => {
    let { storeName } = storeDetail
    let { name, offsetY } = dealStoreName(storeName)
    if (label) map.removeOverlay(label)
    let opts = {
      position: new BMap.Point(location.longitude, location.latitude), // 指定文本标注所在的地理位置
      offset: new BMap.Size(-46, offsetY) // 设置文本偏移量
    }
    label = new BMap.Label(name, opts)
    label.setStyle(labelStyle)
    label.setZIndex(zIndex)
    map.addOverlay(label)
  }
  // 切换门店点时候，中心点偏移
  const setCenter = (location) => {
    let point = new BMap.Point(location.longitude, location.latitude)
    map.setCenter(point)
  }
  // 地图初始化方法
  const initBMap = async (location) => {
    if (baiduRef && baiduRef.current) {
      let latitude = location.latitude
      let longitude = location.longitude
      const myIcon = new BMap.Icon(markerImg, new BMap.Size(20, 32))
      map = new BMap.Map(baiduRef.current) // 创建Map实例
      let point = new BMap.Point(longitude, latitude)
      centerMarker = new BMap.Marker(point, {
        icon: myIcon
      }) // 创建标注
      map.centerAndZoom(point, 16)
      map.addOverlay(centerMarker)
      setMapEnd(true)
    }
  }
  // 地图选择中心点
  const changeCenter = async ({ point, title }) => {
    map.removeOverlay(centerMarker)
    const myIcon = new BMap.Icon(markerImg, new BMap.Size(20, 32))
    let pointI = new BMap.Point(point.lng, point.lat)
    centerMarker = new BMap.Marker(point, {
      icon: myIcon
    }) // 创建标注
    locationMobx.setLocationIsOpen(true)
    locationMobx.setLocation({
      longitude: point.lng,
      latitude: point.lat
    })
    restaurantCenter.setConfig({
      lbs: {
        lat: point.lat,
        lng: point.lng,
      }
    })
    centerMarker.setZIndex(1)
    map.addOverlay(centerMarker)
    map.setCenter(pointI)
    mapShow(false)
    setIsStoreMore(false)
    setSearchTitle(title)
  }
  // 商户标记的方法,执行一次
  const storeMarker = async (handleStoreClassify) => {
    const myIcon = new BMap.Icon(markerImgStore, new BMap.Size(34, 42))
    const storeChangeImgIcon = new BMap.Icon(storeChangeImg, new BMap.Size(164, 50))
    handleStoreClassify.boughtList.forEach((item) => {
      let icon = myIcon
      let zIndex = 2
      if (restaurantConfig.storeId === item.storeId) {
        zIndex = 5
        icon = storeChangeImgIcon
        setLabel(item, {
          longitude: item.lbsLng, latitude: item.lbsLat
        }, zIndex + 1)
      }
      let point = new BMap.Point(item.lbsLng, item.lbsLat)
      let marker = new BMap.Marker(point, {
        icon
      })
      marker.setZIndex(zIndex)
      marker.addEventListener('click', () => {
        const location = {
          longitude: point.lng,
          latitude: point.lat
        }
        const storeDetail = {
          ...item
        }
        setCenter(location)
        setLabel(storeDetail, location, zIndex + 1)
        onSelectStore(storeDetail)
      })
      map.addOverlay(marker)
    })
    handleStoreClassify.moreList.forEach((item) => {
      let icon = myIcon
      let zIndex = 2
      if (restaurantConfig.storeId === item.storeId) {
        icon = storeChangeImgIcon
        zIndex = 5
        setLabel(item, {
          longitude: item.lbsLng, latitude: item.lbsLat
        }, zIndex + 1)
      }
      let point = new BMap.Point(item.lbsLng, item.lbsLat)
      let marker = new BMap.Marker(point, {
        icon
      })
      marker.setZIndex(zIndex)
      marker.addEventListener('click', () => {
        const location = {
          longitude: point.lng,
          latitude: point.lat
        }
        const storeDetail = {
          ...item
        }
        setCenter(location)
        setLabel(storeDetail, location, zIndex + 1)
        onSelectStore(storeDetail)
      })
      map.addOverlay(marker)
    })
  }
  useLayoutEffect(() => {
    // 挂起执行，睡眠方法
    const $sleep = sleep(() => {
      return window.initBaiduMapSDKStatus
    }, 300)
    $sleep(() => {
      initBMap(location)
      storeMarker(handleStoreClassify)
    })
  }, [])
  useLayoutEffect(() => {
    if (!mapEnd) return
    setCenter(location)
    storeDetail && setLabel(storeDetail, location)
  }, [location, storeDetail, mapEnd])
  return (
    <div className='mkt-baidu store-map-show-area'>
      {isSearch && (
        <div className='info'>
          <Icon
            name='chevron-left'
            onClick={() => {
              mapShow(false)
            }}
          />
          <Input
            placeholder={i18n.t('store.storeGoAdd')}
            onChange={(e: any) => searchLocal(e.target.value)}
            autoFocus
          />
        </div>
      )}
      {
        isSearch && (
          <div
            className='search-area'
          >
            {
              searchArr.map((item: any, index: number) => {
                return (
                  <div
                    key={index} className='search-item'
                    onClick={() => {
                      changeCenter(item)
                    }}
                  >
                    <div className='title'>{item.title}</div>
                    <div className='des'>{item.province}{item.city}{item.address || ''}</div>
                  </div>
                )
              })
            }
          </div>
        )
      }
      <div className='baidu-map-show' ref={baiduRef}></div>
    </div>
  )
}

export default BaiduMap
